import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const InfoLabel = styled(Typography)`
  margin-right: 8px;
  display: inline-block;
`

export default InfoLabel
